import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { WizardStepDirective } from './dialog-wizard.directive';

@Component({
  selector: 'ngx-dialog-wizard-base',
  templateUrl: './dialog-wizard.component.html',
  styleUrls: ['./dialog-wizard.component.scss'],
})
export class DialogWizardComponent implements AfterContentInit {
  @ContentChildren(WizardStepDirective) steps!: QueryList<WizardStepDirective>;

  @Input() data: any = {};
  stepIndex = 0;

  protected cdr = inject(ChangeDetectorRef);

  constructor(
    protected dialogRef: NbDialogRef<any>,
  ) {}

  ngAfterContentInit() {
    if (this.steps.length === 0) {
      console.warn('⚠️ No wizard steps found!');
    }

    // Sometimes QueryList updates after first change detection cycle
    this.cdr.detectChanges();
  }

  get totalSteps() {
    return this.steps?.length || 0;
  }

  next() {
    if (this.stepIndex < this.totalSteps - 1) this.stepIndex++;
  }

  prev() {
    if (this.stepIndex > 0) this.stepIndex--;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  finish() {
    this.dialogRef.close(this.data);
  }
}
